import { Stack, Box, Typography } from '@mui/material';
import {
    IdentityStepScanFaceIcon,
    IdentityStepTakePictureIcon,
    IdentityStepTypeIdIcon,
} from '@/assets/theme/default/identityIcons';
import { usePhrase } from '@/hooks/general';
import { IDENTITY_PHRASES } from '@/consts/phrases/registrationPhrases';

import styles from './YotiStepsDescriptionBox.module.css';

export const YotiStepsDescriptionBox = () => {
    const { t } = usePhrase();
    return (
        <Box className={styles.steps}>
            <Stack
                direction="row"
                className={styles.stepsContainer}
                sx={{
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                }}
            >
                <Box className={`${styles.stepItem} ${styles.step1}`}>
                    <Box className={styles.stepIcon}>
                        <IdentityStepTypeIdIcon />
                    </Box>
                    <Typography variant="h6" className={styles.stepTitle}>
                        {t(IDENTITY_PHRASES.STEP_ID_TYPE_TEXT)}
                    </Typography>
                </Box>
                <Box className={`${styles.stepItem} ${styles.step2}`}>
                    <Box className={styles.stepIcon}>
                        <IdentityStepTakePictureIcon />
                    </Box>
                    <Typography variant="h6" className={styles.stepTitle}>
                        {t(IDENTITY_PHRASES.STEP_TAKE_PICTURE_TEXT)}
                    </Typography>
                </Box>
                <Box className={`${styles.stepItem} ${styles.step3}`}>
                    <Box className={styles.stepIcon}>
                        <IdentityStepScanFaceIcon />
                    </Box>
                    <Typography variant="h6" className={styles.stepTitle}>
                        {t(IDENTITY_PHRASES.STEP_SCAN_FACE_TEXT)}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
};
